<script>
import * as microsoftTeams from "@microsoft/teams-js";
import { TeamsMsal2Provider } from "@microsoft/mgt-teams-msal2-provider";

TeamsMsal2Provider.microsoftTeamsLib = microsoftTeams;
TeamsMsal2Provider.handleAuth();
export default {};
</script>
